import { amber, green } from '@material-ui/core/colors'

export default (theme) => ({
  root: {
    display: 'flex',
    flexWrap: 'noWrap',
    marginRight: theme.spacing(4),
  },
  success: {
    backgroundColor: green[600],
  },
  error: {
    backgroundColor: theme.palette.error.dark,
  },
  info: {
    backgroundColor: theme.palette.primary.main,
  },
  warning: {
    backgroundColor: amber[700],
  },
  icon: {
    fontSize: 20,
  },
  iconVariant: {
    opacity: 0.9,
    marginRight: theme.spacing(1),
  },
})
